<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div *ngIf="EstCharge()" class="fluid formgrid grid">

    <!-- Upload Progress Banner -->
    <div *ngIf="uploadingFiles.size > 0" class="col-12 mb-3">
        <p-card>
            <div class="flex flex-column gap-3">
                <div class="flex justify-content-between align-items-center">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-cloud-upload text-2xl text-primary"></i>
                        <div>
                            <h4 class="m-0">Téléchargement en cours</h4>
                            <p class="m-0 text-sm text-500">
                                <span *ngIf="getUploadingFilesCount() > 0">
                                    {{ getUploadingFilesCount() }} fichier(s) en cours
                                </span>
                                <span *ngIf="getSuccessFilesCount() > 0" class="ml-2 text-green-500">
                                    <i class="pi pi-check-circle"></i> {{ getSuccessFilesCount() }} réussi(s)
                                </span>
                                <span *ngIf="getFailedFilesCount() > 0" class="ml-2 text-red-500">
                                    <i class="pi pi-times-circle"></i> {{ getFailedFilesCount() }} échoué(s)
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="flex gap-2">
                        <p-button *ngIf="getUploadingFilesCount() === 0 && getSuccessFilesCount() > 0" label="Effacer"
                            icon="pi pi-check" styleClass="p-button-sm p-button-success"
                            (click)="clearCompletedUploads()"></p-button>
                        <p-button icon="pi pi-times" styleClass="p-button-sm p-button-text"
                            [disabled]="getUploadingFilesCount() > 0" (click)="dismissUploadBanner()"></p-button>
                    </div>
                </div>

                <!-- Overall Progress Bar -->
                <div *ngIf="getUploadingFilesCount() > 0">
                    <p-progressBar [value]="getOverallUploadProgress()" [showValue]="true"></p-progressBar>
                </div>

                <!-- Individual File Progress -->
                <div *ngIf="uploadingFiles.size > 0" class="upload-files-list">
                    <div *ngFor="let entry of uploadingFiles | keyvalue" class="upload-file-item">
                        <div class="flex justify-content-between align-items-center gap-2 p-2">
                            <div class="flex align-items-center gap-2 flex-1 overflow-hidden">
                                <i *ngIf="entry.value.status === 'uploading'"
                                    class="pi pi-spin pi-spinner text-primary"></i>
                                <i *ngIf="entry.value.status === 'success'"
                                    class="pi pi-check-circle text-green-500"></i>
                                <i *ngIf="entry.value.status === 'error'" class="pi pi-times-circle text-red-500"></i>
                                <span
                                    class="text-sm font-medium overflow-hidden text-overflow-ellipsis white-space-nowrap">
                                    {{ entry.value.fileName }}
                                </span>
                            </div>
                            <div class="flex align-items-center gap-2">
                                <span *ngIf="entry.value.status === 'uploading'" class="text-sm text-500">
                                    {{ entry.value.progress }}%
                                </span>
                                <span *ngIf="entry.value.status === 'error'" class="text-xs text-red-500"
                                    [pTooltip]="entry.value.error" tooltipPosition="left">
                                    Échec
                                </span>
                                <p-button *ngIf="entry.value.status === 'error'" icon="pi pi-refresh"
                                    styleClass="p-button-sm p-button-text p-button-rounded" pTooltip="Réessayer"
                                    (click)="retryUpload(entry.value)"></p-button>
                            </div>
                        </div>
                        <p-progressBar *ngIf="entry.value.status === 'uploading'" [value]="entry.value.progress"
                            [showValue]="false" styleClass="upload-progress-bar-small"></p-progressBar>
                    </div>
                </div>

                <!-- Failed Uploads Summary -->
                <div *ngIf="getFailedFilesCount() > 0 && getUploadingFilesCount() === 0"
                    class="p-3 border-round surface-ground">
                    <div class="flex align-items-center gap-2 mb-2">
                        <i class="pi pi-exclamation-triangle text-orange-500"></i>
                        <span class="font-medium">Échecs de téléchargement</span>
                    </div>
                    <p class="text-sm text-500 m-0">
                        Certains fichiers n'ont pas pu être téléchargés. Vous pouvez cliquer sur le bouton de réessayer
                        pour chaque fichier.
                    </p>
                </div>
            </div>
        </p-card>
    </div>

    <p-menu #menuContextuelDocuments popup="popup" [model]="contenuMenuContextuelDocuments">
    </p-menu>

    <p-menu #menuContextuelFichiers popup="popup" [model]="contenuMenuContextuelFichiers">
    </p-menu>

    <p-contextMenu [model]="itemsContextMenuDocuments" />

    <input type="file" #fileInput (change)="onFileChange($event)" style="display: none;" multiple>
    <input type="file" #folderInput webkitdirectory (change)="onFileChange($event)" style="display: none;" multiple>

    <!-- Drawer for mobile -->
    <p-sidebar [(visible)]="drawerVisible" position="left" [modal]="true" [style]="{width:'85vw'}"
        [breakpoints]="{'960px': '75vw'}" [showCloseIcon]="false" styleClass="p-sidebar-md">
        <ng-template pTemplate="header">
            <div class="flex justify-content-between align-items-center w-full">
                <h3 class="m-0">Dossiers</h3>
                <button pButton pRipple icon="pi pi-times" class="p-button-rounded p-button-text"
                    (click)="drawerVisible = false"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <div *ngIf="showFolders">
                <button *ngIf="!readonly" pButton type="button" icon="pi pi-plus" (click)="ajouterDocument($event)"
                    label="Ajouter un document" class="mb-1 w-full" [disabled]="hasActiveUploads()"
                    [pTooltip]="hasActiveUploads() ? 'Téléchargement en cours...' : ''"
                    tooltipPosition="bottom"></button>
                <p-tree #menudossiers [value]="typesDocuments" selectionMode="single" draggableNodes
                    [contextMenu]="menuContextuelFichiers" [(selection)]="selectionTypeDocument"
                    (onNodeSelect)="onSelectionDocument($event)"
                    (onNodeContextMenuSelect)="onFileRightClick($event.originalEvent, $event.node)"
                    (contextmenu)="$event.preventDefault()">
                </p-tree>
            </div>
        </ng-template>
    </p-sidebar>
    <p-splitter [panelSizes]="isMobile || !typesDocuments.length ? [1, 100] : [20, 80]" [minSizes]="[0, 60]" styleClass="w-full" class="w-full">
        <ng-template pTemplate>
            <div *ngIf="showFolders && typesDocuments.length" class="hidden md:block">
                <div class="flex flex-column gap-2">
                    <button *ngIf="!readonly" pButton type="button" icon="pi pi-plus" (click)="ajouterDocument($event)"
                        label="Ajouter un document" class="mb-1 mr-2" [disabled]="hasActiveUploads()"
                        [pTooltip]="hasActiveUploads() ? 'Téléchargement en cours...' : ''"
                        tooltipPosition="right"></button>
                    <p-tree #menudossiers [value]="typesDocuments" selectionMode="single" draggableNodes
                        [contextMenu]="menuContextuelFichiers" [(selection)]="selectionTypeDocument"
                        (onNodeSelect)="onSelectionDocument($event)"
                        (onNodeContextMenuSelect)="onFileRightClick($event.originalEvent, $event.node)"
                        (contextmenu)="$event.preventDefault()">
                    </p-tree>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate>
            <div class="w-full pl-4 drop-zone-container" 
                [class.drag-over]="isDraggingOver"
                (drop)="onFilesDropped($event)" 
                (dragover)="onDragOver($event)" 
                (dragleave)="onDragLeave($event)">
                
                <!-- Drop Zone Overlay -->
                <div *ngIf="isDraggingOver" class="drop-zone-overlay">
                    <div class="drop-zone-content">
                        <i class="pi pi-cloud-upload"></i>
                        <span>Déposez vos fichiers ici</span>
                    </div>
                </div>
                
                <p-dataView #dv [value]="documentsFiltres()" [layout]="layout()" [rows]="rows()" [totalRecords]="documentsFiltres().length"
                    [rowsPerPageOptions]="[8, 16, 32, 64]" [paginator]="true" [(first)]="first" [sortField]="sortField()"
                    [sortOrder]="sortOrder()" filterBy="nom" (onPage)="onLazyLoad($event)"
                    (onChangeLayout)="layout.set($event.layout)">
                    <ng-template pTemplate="header">
                        <div class="flex flex-wrap justify-content-between mt-3 md:mt-0 gap-2">
                            <div class="flex flex-wrap gap-2">
                                <!-- Go to Parent Folder Button -->
                                <button *ngIf="isInSubfolder()" pButton type="button" icon="pi pi-arrow-up"
                                    label="Dossier parent" class="p-button-outlined p-button-sm"
                                    (click)="goToParentFolder()" pTooltip="Retourner au dossier parent"
                                    tooltipPosition="bottom"></button>

                                <!-- Mobile folders toggle button -->
                                <button *ngIf="showFolders" pButton type="button" icon="pi pi-bars" label="Dossiers"
                                    class="md:hidden p-button-text" (click)="drawerVisible = true"
                                    [disabled]="hasActiveUploads()"></button>

                                <button *ngIf="(!showFolders || isMobile) && !readonly" pButton type="button"
                                    icon="pi pi-plus" (click)="ajouterDocument($event)" label="Ajouter un document"
                                    class="mb-1" [disabled]="hasActiveUploads()"
                                    [pTooltip]="hasActiveUploads() ? 'Téléchargement en cours...' : ''"
                                    tooltipPosition="bottom"></button>
                                <p-dropdown [options]="sortOptions" [ngModel]="sortField()"
                                    (onChange)="onSortChange($event)" />
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input type="text" pInputText placeholder="Rechercher..." [(ngModel)]="searchText"
                                        (input)="onSearch($event)">
                                </span>
                            </div>
                            <p-dataViewLayoutOptions [layout]="layout()" />
                        </div>
                    </ng-template>
                    <ng-template let-docs pTemplate="grid">
                        <!-- Breadcrumb Navigation -->
                        <div *ngIf="isInSubfolder()" class="my-3">
                            <div class="flex align-items-center gap-2 text-sm text-500">
                                <i class="pi pi-folder"></i>
                                <span>{{ selectionTypeDocument()?.label }}</span>
                            </div>
                        </div>

                        <div *ngIf="docs.length != 0" class="grid mt-3">
                            <p-fieldset *ngIf="dossierFiltres().length > 0 && first() == 0" legend="Dossiers"
                                [toggleable]="true" [collapsed]="true" class="w-full col-12">
                                <!-- Dynamic Folders -->
                                <div class="grid" styleClass="h-full w-full">
                                    <div *ngFor="let folder of dossierFiltres()"
                                        class="col-12 md:col-4 lg:col-3 my-3">
                                        <div class="flex justify-content-center align-items-center cursor-pointer w-full h-full"
                                            (mouseup)="onFolderClick(folder)">
                                            <div class="flex flex-column align-items-center gap-2">
                                                <i class="pi pi-folder text-primary" style="font-size: 50px;"></i>
                                                <span class="text-sm font-medium text-center">{{ folder.label }}</span>
                                                <span class="text-xs text-500">({{ folder.documentCount }} fichier{{
                                                    folder.documentCount > 1 ? 's' : '' }})</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </p-fieldset>

                            <!-- Documents -->
                            <div *ngFor="let doc of docs" class="col-12 md:col-4 lg:col-3 my-3" styleClass="h-full"
                                (contextmenu)="surMenuContextuelDocuments($event, doc); $event.preventDefault()">
                                <div #divImage style="display: flex; justify-content: center; position: relative;"
                                    [class.uploading-document]="isDocumentUploading(doc)">

                                    <!-- Upload Progress Overlay -->
                                    <div *ngIf="isDocumentUploading(doc)" class="upload-overlay">
                                        <div class="flex flex-column align-items-center justify-content-center gap-2"
                                            style="width: 160px; height: 160px;  border-radius: 8px;">
                                            <i class="pi pi-cloud-upload text-4xl text-primary"></i>
                                            <span class="text-sm font-medium">Téléchargement...</span>
                                            <p-progressBar [value]="getDocumentUploadProgress(doc)" [showValue]="true"
                                                styleClass="w-9"></p-progressBar>
                                        </div>
                                    </div>

                                    <div *ngIf="doc.apercu && !isDocumentUploading(doc)">
                                        <p-image [src]="doc.apercu" [previewImageSrc]="doc.previewUrl || doc.apercu"
                                            [alt]="doc.nom"
                                            [style]="{maxWidth: divImage.clientWidth - 10 + 'px', overflow: 'hidden'}"
                                            height="160" preview="true" (onShow)="loadPreviewImage(doc)" />
                                    </div>
                                    <div *ngIf="!doc.apercu && !isDocumentUploading(doc)"
                                        class="flex justify-content-center align-items-center ml-2"
                                        style="width: 160px; height: 160px;">
                                        <p-progressSpinner *ngIf="doc.loading" styleClass="w-4rem h-4rem"
                                            strokeWidth="4"></p-progressSpinner>
                                        <i *ngIf="doc.typeFichier == ETypeFichier.Image && !doc.loading"
                                            class="pi pi-exclamation-triangle" style="font-size: 40px;color: red"
                                            pTooltip="Apercu indisponible" tooltipPosition="bottom"></i>
                                        <div *ngIf="doc.typeFichier == ETypeFichier.Video && !doc.loading"
                                            class="flex justify-content-center align-items-center cursor-pointer"
                                            (click)="afficherVideo(doc)"
                                            style="width: 160px; height: 160px; position: relative;">
                                            <i class="pi pi-video" style="font-size: 60px; color: #666"></i>
                                            <div class="play-button"
                                                style="position: absolute; width: 50px; height: 50px; border-radius: 50%; display: flex; justify-content: center; align-items: center; box-shadow: 0 2px 4px rgba(0,0,0,0.2); transition: transform 0.2s">
                                                <i class="pi pi-play"
                                                    style="font-size: 24px; color: #2196F3; margin-left: 4px"></i>
                                            </div>
                                        </div>
                                        <i *ngIf="doc.typeFichier == ETypeFichier.Autre && !doc.loading"
                                            class="pi pi-file-o" style="font-size: 60px"></i>
                                    </div>
                                </div>
                                <div class="flex flex-column align-content-center justify-content-between w-full">
                                    <div class="flex flex-column align-items-center w-full">
                                        <div
                                            class="flex align-items-center justify-content-center gap-2 mt-2 mb-1 flex-wrap">
                                            <p-tag *ngIf="doc.indPrincipale" severity="success" value="Principale"
                                                pTooltip="Utilisé pour l'aperçu de l'article"
                                                tooltipPosition="top"></p-tag>
                                            <h6 class="m-0 font-medium">{{doc.nom}}</h6>
                                            <i *ngIf="doc.public" class="pi pi-globe text-sm text-primary"
                                                pTooltip="Document public"></i>
                                        </div>
                                        <div *ngIf="doc.description"
                                            class="text-sm text-500 overflow-hidden text-overflow-ellipsis"
                                            style="white-space: pre-wrap;" [pTooltip]="doc.description">
                                            {{doc.description}}
                                        </div>
                                        <div class="text-xs">{{doc.date | date:'yyyy-MM-dd'}}</div>
                                        <div *ngIf="doc.typeDocument" class="text-xs">
                                            <i class="pi pi-folder mr-1"></i>
                                            <span class="dossierFichier">{{doc.typeDocument?.nom}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="flex justify-content-center align-items-center w-full gap-6 mt-3">
                                        <div class="flex gap-1">
                                            <p-button outlined (click)="telechargerDocument(doc)" icon="pi pi-download"
                                                pTooltip="Télécharger le fichier" tooltipPosition="top"
                                                title="Télécharger le fichier"></p-button>
                                        </div>
                                        <div *ngIf="!readonly">
                                            <p-menu #optionsmenu [model]="contenuMenuContextuelDocuments" [popup]="true"
                                                appendTo="body" />
                                            <p-button text
                                                *ngIf="estAutorise('item_document_modifier') || estAutorise('item_document_supprimer')"
                                                pRipple icon="pi pi-bars" severity="secondary" pTooltip="Options"
                                                tooltipPosition="top"
                                                (onClick)="surMenuContextuelDocuments($event, doc)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-docs pTemplate="list">
                        <!-- Breadcrumb Navigation for List View -->
                        <div *ngIf="isInSubfolder()" class="my-3">
                            <div class="flex align-items-center gap-2 text-sm text-500">
                                <i class="pi pi-folder"></i>
                                <span>{{ selectionTypeDocument()?.label }}</span>
                            </div>
                        </div>

                        <div *ngIf="dossierFiltres().length > 0 && first() == 0">
                            <!-- Dynamic Folders in List View -->
                            <div *ngFor="let folder of dossierFiltres()" class="mt-3">
                                <div class="flex justify-content-between align-items-center w-full p-3 border-1 surface-border border-round cursor-pointer hover:surface-hover"
                                    (mouseup)="onFolderClick(folder)">
                                    <div class="flex align-items-center gap-3">
                                        <div class="flex justify-content-center align-items-center"
                                            style="width: 50px; height: 50px;">
                                            <i class="pi pi-folder text-3xl text-primary"></i>
                                        </div>
                                        <div class="flex flex-column">
                                            <span class="font-medium">{{ folder.label }}</span>
                                            <span class="text-sm text-500">{{ folder.documentCount }} fichier{{
                                                folder.documentCount > 1 ? 's' : '' }}</span>
                                        </div>
                                    </div>
                                    <div class="flex align-items-center gap-2">
                                        <i class="pi pi-chevron-right text-500"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Documents in List View -->
                        <div *ngFor="let doc of docs" class="mt-3"
                            [class.uploading-document-row]="isDocumentUploading(doc)">
                            <div>
                                <div class="flex justify-content-between align-items-center w-full">
                                    <div class="flex align-items-center gap-1">
                                        <div #divImage class="flex justify-content-center align-items-center"
                                            style="width: 50px; height: 50px; position: relative;">

                                            <!-- Upload indicator for list view -->
                                            <div *ngIf="isDocumentUploading(doc)"
                                                class="flex flex-column align-items-center justify-content-center"
                                                style="width: 50px; height: 50px;">
                                                <i class="pi pi-cloud-upload text-2xl text-primary"></i>
                                                <span class="text-xs">{{ getDocumentUploadProgress(doc) }}%</span>
                                            </div>

                                            <div *ngIf="doc.apercu && !isDocumentUploading(doc)">
                                                <p-image [src]="doc.apercu"
                                                    [previewImageSrc]="doc.previewUrl || doc.apercu" [alt]="doc.nom"
                                                    height="50" preview="true"
                                                    [style]="{maxWidth: divImage.clientWidth - 10 + 'px', overflow: 'hidden'}"
                                                    (onShow)="loadPreviewImage(doc)" />
                                                <i *ngIf="doc.indPrincipale" class="pi pi-star-fill"
                                                    style="position: absolute; top: 2px; right: 2px; color: #FFD700; font-size: 12px; text-shadow: 1px 1px 2px rgba(0,0,0,0.5);"
                                                    pTooltip="Image principale"></i>
                                            </div>
                                            <div *ngIf="doc.typeFichier == ETypeFichier.Video && !doc.loading && !isDocumentUploading(doc)"
                                                class="flex justify-content-center align-items-center cursor-pointer"
                                                (click)="afficherVideo(doc)"
                                                style="width: 160px; height: 160px; position: relative;">
                                                <i class="pi pi-video" style="font-size: 60px; color: #666"></i>
                                                <div class="play-button"
                                                    style="position: absolute; width: 50px; height: 50px; border-radius: 50%; display: flex; justify-content: center; align-items: center; box-shadow: 0 2px 4px rgba(0,0,0,0.2); transition: transform 0.2s">
                                                    <i class="pi pi-play"
                                                        style="font-size: 24px; color: #2196F3; margin-left: 4px"></i>
                                                </div>
                                            </div>
                                            <div *ngIf="!doc.apercu && !isDocumentUploading(doc)">
                                                <p-progressSpinner *ngIf="doc.loading" styleClass="w-4rem h-4rem"
                                                    strokeWidth="4"></p-progressSpinner>
                                                <i *ngIf="doc.typeFichier == ETypeFichier.Image && !doc.loading"
                                                    class="pi pi-exclamation-triangle"
                                                    style="font-size: 30px;color: red" pTooltip="Apercu indisponible"
                                                    tooltipPosition="bottom"></i>
                                                <i *ngIf="doc.typeFichier == ETypeFichier.Autre && !doc.loading"
                                                    class="pi pi-file-o" style="font-size: 30px"></i>
                                            </div>
                                        </div>
                                        <p-divider layout="vertical"></p-divider>
                                        <div class="flex flex-column flex-1">
                                            <div class="flex align-items-center gap-2">
                                                <h5 class="m-0 font-medium" style="word-break: break-word;">{{doc.nom}}
                                                </h5>
                                                <i *ngIf="doc.public" class="pi pi-globe text-sm text-primary"
                                                    pTooltip="Document public"></i>
                                                <i *ngIf="doc.indPrincipale"
                                                    class="pi pi-star-fill text-sm text-yellow-500"
                                                    pTooltip="Image principale de l'article"></i>
                                            </div>
                                            <div *ngIf="doc.description"
                                                class="text-sm text-500 overflow-hidden text-overflow-ellipsis"
                                                style="white-space: nowrap; max-width: 40vw;"
                                                [pTooltip]="doc.description">
                                                {{doc.description}}</div>
                                            <div class="text-xs">{{doc.date | date:'yyyy-MM-dd'}}</div>
                                            <div *ngIf="doc.typeDocument" class="text-xs">
                                                <i class="pi pi-folder mr-1"></i>
                                                <span class="dossierFichier">{{doc.typeDocument?.nom}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex gap-3 flex-column md:flex-row">
                                        <p-button (click)="telechargerDocument(doc)" icon="pi pi-download"></p-button>
                                        <div *ngIf="!readonly">
                                            <p-confirmPopup>
                                                <ng-template pTemplate="content" let-message>
                                                    <div
                                                        class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border p-3 mb-3">
                                                        <i [class]="message.icon" class="text-6xl text-primary-500"></i>
                                                        <p>{{ message.message }}</p>
                                                    </div>
                                                </ng-template>
                                            </p-confirmPopup>
                                            <p-menu #optionsmenu [model]="contenuMenuContextuelDocuments" [popup]="true"
                                                appendTo="body" />
                                            <p-button
                                                *ngIf="estAutorise('item_document_modifier') || estAutorise('item_document_supprimer')"
                                                pRipple icon="pi pi-bars" severity="secondary"
                                                (onClick)="surMenuContextuelDocuments($event, doc)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p-divider></p-divider>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="empty">
                        <div class="flex flex-column align-items-center justify-content-center h-full"
                            style="margin-top: 50px;">
                            <i class="pi pi-file-o text-6xl text-primary-500"></i>
                            <p>Aucun document</p>
                        </div>
                    </ng-template>
                </p-dataView>
            </div>
        </ng-template>
    </p-splitter>
</div>

<p-sidebar #sidebarAjoutDocument [(visible)]="visibleSidebarAjoutDocument" [fullScreen]="isMobile" position="right" styleClass="w-full md:w-6">
    <ng-template pTemplate="header">
        <h3 class="m-0 text-xl font-medium">Ajouter un document</h3>
    </ng-template>

    <div class="flex flex-column gap-2 justify-content-between h-full">
        <div class="flex-1">
            <div class="field mb-4">
                <label class="block text-sm mb-2">Date</label>
                <p-calendar [(ngModel)]="requeteAjouterDocuments.date" [showIcon]="true" dateFormat="dd MM yy"
                    [yearNavigator]="true" [monthNavigator]="true" styleClass="w-full" appendTo="self">
                </p-calendar>
                <small class="p-error block mt-1" *ngIf="submitted && !requeteAjouterDocuments.date">La date est
                    obligatoire</small>
            </div>

            <div class="field mb-4" *ngIf="showFolders">
                <label class="block text-sm mb-2">Dossier</label>
                <p-treeSelect [options]="this.typesDocuments" [(ngModel)]="selectionTypeDocument" [autofocus]="true"
                    placeholder="Sélectionnez un dossier parent..." [filter]="true"
                    filterPlaceholder="Rechercher un dossier..." [showClear]="true" [selectionMode]="'single'"
                    [metaKeySelection]="false" styleClass="w-full">
                </p-treeSelect>
                <small class="p-error block mt-1" *ngIf="submitted && !selectionTypeDocument()">Le dossier
                    est
                    obligatoire</small>
            </div>

            <div class="flex gap-2">
                <p-button *ngFor="let item of contenuMenuAjoutDocument" (click)="item.command()" [icon]="item.icon"
                    [label]="item.label" styleClass="p-button-outlined w-full" class="flex-grow-1">
                </p-button>
            </div>

            <!-- Files to Upload Preview -->
            <div *ngIf="files().length > 0" class="mt-4">
                <div class="flex justify-content-between align-items-center mb-2">
                    <h4 class="m-0 text-sm font-medium">Fichiers à télécharger ({{ files().length }})</h4>
                    <p-button icon="pi pi-trash" label="Tout supprimer"
                        styleClass="p-button-sm p-button-text p-button-danger" (click)="clearAllFiles()"></p-button>
                </div>
                <div class="flex flex-column gap-2 max-h-30rem overflow-y-auto">
                    <div *ngFor="let file of files(); let i = index; trackBy: trackByIndex" class="border-1 surface-border border-round p-2">
                        <div class="flex gap-2 align-items-start">
                            <!-- Image Preview (if applicable) -->
                            <div *ngIf="isImageFile(file)" class="flex-shrink-0 md:block"
                                style="width: 60px; height: 60px;">
                                <img [src]="file.preview" alt="preview" class="w-full h-full border-round"
                                    style="object-fit: cover;">
                            </div>
                            <i *ngIf="!isImageFile(file)" class="pi pi-file text-3xl flex-shrink-0"></i>

                            <!-- File Details -->
                            <div class="flex-1 min-w-0">
                                <!-- Folder Path -->
                                <div *ngIf="getFileFolder(file)" class="text-xs mb-1 flex align-items-center gap-1">
                                    <i class="pi pi-folder text-xs"></i>
                                    <span class="font-medium">{{ getFileFolder(file) }}</span>
                                </div>

                                <!-- Editable File Name -->
                                <input type="text" pInputText [ngModel]="file.name" (ngModelChange)="changeFileName(file, $event)" class="w-full text-sm p-1 mb-1"
                                    placeholder="Nom du fichier">

                                <!-- File Size -->
                                <div class="text-xs flex gap-2">
                                    <span>{{ formatFileSize(file.size) }}</span>
                                    <i class="pi pi-pencil text-sm text-primary cursor-pointer"
                                        pTooltip="Ajouter une description du fichier" tooltipPosition="left"
                                        (click)="file.voirDescription = !file.voirDescription"> Description</i>
                                </div>

                                <!-- File Description -->
                                <textarea pInputTextarea *ngIf="file.voirDescription" [(ngModel)]="file.description"
                                    class="w-full text-sm p-1 my-1" placeholder="Description"></textarea>
                            </div>

                            <!-- Remove Button -->
                            <p-button icon="pi pi-times"
                                styleClass="p-button-sm p-button-text p-button-rounded p-button-danger"
                                (click)="removeFile(i)" pTooltip="Retirer ce fichier" tooltipPosition="left"></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-content-end gap-1">
            <p-button label="Annuler" (click)="visibleSidebarAjoutDocument = false"
                styleClass="p-button-outlined"></p-button>
            <p-button label="Confirmer" styleClass="p-button-primary" (click)="ajouterDocuments()"></p-button>
        </div>
    </div>
</p-sidebar>